import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "./Hero/Hero";
import { useRef } from "react";
import Navbar from "./component/Navbar/NavBar";
import FAQ from "./FAQ/faq";
// import KeyFeatures from "./KeyFeatures/KeyFeatures";
// import Contribute from "./SaveAndContribute/Contribute";
import Footer from "./Footer/Footer";
import HowItWorks from "./pages/HowitWorks/HowitWorks";
import AboutUs from "./pages/About/about";
import Privacy from "./pages/Privacy/Privacy";
import Terms from "./pages/Terms/Terms";
import NotFound from "./pages/NotFound/NotFound";

function App() {
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);
  // const AboutUsRef = useRef(null);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar FooterRef={FooterRef} HowitworksRef={HowitworksRef} AboutRef={AboutRef} FAQRef={FAQRef} />
              <Hero FooterRef={FooterRef} FAQRef={FAQRef} AboutRef={AboutRef} />
              {/* <div ref={AboutRef}>
                <KeyFeatures />
              </div> */}
              {/* <div ref={HowitworksRef}>
                <Contribute />
              </div> */}
              <div ref={FAQRef}>
                <FAQ />
              </div>
              
              <div ref={FooterRef}>
                <Footer />
              </div>
            </>
          }
        />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
